import * as React from "react";
import {getAmountWithDecimalDigits} from "@ferry/plugin-ferry-journey";
import DirectDebitPaymentSchedule from "../../../../../components/widgets/DirectDebitPaymentSchedule";

interface IProps {
    interaction: any,
}

interface IState {
    isOpen: boolean;
}

export class DirectDebitRenewalMigratedPaymentPlanOutput extends React.Component <IProps, IState> {

    constructor(props: IProps) {
        super(props)

        this.state = {
            isOpen: false
        };
    }

    public render() {
        return (
            <>
                <strong>Payment schedule</strong>
                {this.renderContent()}
            </>
        )
    }

    private readonly renderContent = () => {
        const interaction = this.props.interaction
        const instalment = interaction.paymentDetails.instalmentPlan.instalments[1];
        const totalAmount = this.props.interaction?.paymentDetails?.instalmentPlan.totalAmount;
        const amount = instalment.principal + instalment.interest;

        return (
            <div className="mt-3 margin-top-0 grid-col-2">
                <p>
                    Below is a list of dates when we'll collect the payments
                    (if your preferred payment date falls on a weekend or Bank Holiday,
                    we'll take the payment on the next closest week day).
                    You have to pay a total of <strong>{getAmountWithDecimalDigits(totalAmount)}</strong> ({this.props.interaction.paymentDetails.instalmentPlan.instalments.length} instalments X {getAmountWithDecimalDigits(amount)})
                </p>
                <div className="mb-3">
                    <DirectDebitPaymentSchedule
                        isOpen={this.state.isOpen}
                        instalments={this.props.interaction.paymentDetails.instalmentPlan.instalments || []}
                        interaction={this.props.interaction}
                        instalmentDueDates={true}
                    />
                </div>
                <div className="text-center">
                    {!this.state?.isOpen ?
                        <button className="direct-debit-btn-text text-center cursor-pointer"
                                onClick={this.toggleInstallmentPlan}>
                            + <span className="text-decoration-underline">View payment plan</span>
                        </button>
                        :
                        <button className="direct-debit-btn-text text-center cursor-pointer"
                                onClick={this.toggleInstallmentPlan}>
                            - <span className="text-decoration-underline">Hide payment plan</span>
                        </button>}
                </div>
            </div>
        )
    }

    private readonly toggleInstallmentPlan: () => void = (): void => {
        this.setState((prevState: Readonly<IState>): { isOpen: boolean } => ({
            isOpen: !prevState.isOpen
        }));
    }
}
